import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import BackEnd from '../backend/BackEnd';
import {successToast} from "../utils/toasts";

class UploadFileModal extends Component {
    static propTypes = {
        entityId: PropTypes.number.isRequired,
        entityName: PropTypes.string.isRequired,
        propertyName: PropTypes.string.isRequired,
        files: PropTypes.array.isRequired,
        onUpload: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        files: this.props.files.map(file => ({...file, isUploading: false}))
    };

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            files: nextProps.files.map(file => ({...file, isUploading: false}))
        })
    }

    render() {
        const {entityId, entityName, propertyName, files, onUpload, ...props} = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Загрузка документов</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table table-bordered table-hover">
                        <tbody>
                        {this.state.files.map((file, i) =>
                            <tr key={i}>
                                <td>
                                    {
                                        file.isUploading
                                            ? (
                                                <div className="progress progress-striped active">
                                                    <div className="progress-bar progress-bar-success" role="progressbar"
                                                         style={{width: '100%'}}>
                                                        {file.name + file.extension}
                                                    </div>
                                                </div>
                                            )
                                            : (
                                                <div className="input-group">
                                                    <input type="text" className="form-control"
                                                           value={file.name}
                                                           onChange={event => this.updateFileName(file, event.target.value)}/>
                                                    <span className="input-group-addon">{file.extension}</span>
                                                    <span className="input-group-btn">
                                                        <button className="btn btn-default"
                                                                onClick={() => this.removeFile(file)}>
                                                            <i className="fa fa-times" aria-hidden="true"/>
                                                        </button>
                                                    </span>
                                                </div>
                                            )
                                    }
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary"
                            onClick={() => this.uploadFiles()}>
                        Загрузить
                    </button>
                    <button type="button" className="btn btn-default"
                            onClick={props.onHide}>
                        Закрыть
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    updateFileName(file, fileName) {
        const {files} = this.state;
        files[files.indexOf(file)].name = fileName;
        this.setState({files});
    }

    removeFile(file) {
        const {files} = this.state;
        files.splice(files.indexOf(file), 1);
        this.setState({files});
    }

    async uploadFiles() {
        const {entityId, entityName, propertyName, onUpload, onHide} = this.props;
        const {files} = this.state;
        const documents = [];

        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let result = await this.uploadFile(file);
            if (result.success) {
                documents.push({
                    name: file.name + file.extension,
                    size: file.size,
                    fileId: result.data
                });
            }
        }

        let uploadDocuments = new BackEnd.Documents.UploadDocuments();
        let result = await uploadDocuments.call({
                entityId,
                entityName,
                propertyName,
                documents
            });

        if (result.success) {
            successToast('Загрузка выполнена успешно');
            onUpload();
            onHide();
        }
    }

    uploadFile(file) {
        return new Promise((resolve, reject) => {
            let uploadFile = new BackEnd.Documents.UploadFile();
            let fileReader = new FileReader();

            fileReader.onload = () => {
                uploadFile.sendFile(fileReader.result)
                    .then(resolve);
            };

            fileReader.readAsArrayBuffer(file.nativeFile);
        });
    }
}

export default UploadFileModal;


// WEBPACK FOOTER //
// ./src/modals/UploadFileModal.js